import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../providers/rest.service';
import {IdIsimDto} from '../model/id-isim-dto';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-sube-ekle-duzenle',
  templateUrl: './sube-ekle-duzenle.component.html',
  styleUrls: ['./sube-ekle-duzenle.component.css']
})
export class SubeEkleDuzenleComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  id: string = null;
  sube: IdIsimDto = null;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private restService: RestService,
              private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      if (this.id !== '0') {

        this.getSube();
      } else {
        this.sube = new IdIsimDto();
        this.sube.isim = '';
        this.sube.teslimatAdresi = '';
        this.sube.satinAlmaMailAdresi = '';
        this.sube.siparisOlusturulduMailAdresi = '';
        this.sube.telefon = '';
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getSube() {
    this.restService.getSube(this.id).subscribe(res => {
      if (res) {
        this.sube = res;
      }
    });
  }

  save() {
    const subscription = res => {
      this.toastrService.show('Kaydedildi', 'Başarılı');
      this.router.navigate(['subeler']);
    };
    if (this.id === '0') {
      this.restService.subeEkle(this.sube).subscribe(subscription);
    } else {
      this.restService.subeDuzenle(this.sube).subscribe(subscription);
    }
  }
}
